
import React from "react";
import Btn from "../common/Btn";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import SectionHead from "../common/SectionHead";
import TournamentCard from "../common/TournamentCard";
import styles from "../../assets/style.module.css";
import { ITournament } from "../../../../../services";

export interface FeaturedTournamentsProps {
    basePath: string;
    tournaments: ITournament[];
    onSelect: (t: ITournament) => void;
}

function FeaturedTournaments({ basePath, tournaments, onSelect }: FeaturedTournamentsProps) {

    const labels = i18nManager.Labels.home;
    const trackRef = React.useRef<HTMLDivElement>(null);
    const scroll = (direction: 1 | -1) => trackRef.current?.scrollBy({ left: direction * trackRef.current.clientWidth * 0.75, behavior: "smooth" });

    return (<section className={styles["section"]}>
        <div className={styles["container"]}>
            <SectionHead tag={labels.featured} title={labels.featured_title} action={<Btn variant="outline" size="sm" to={pagePath(basePath, "TOURNAMENTS")}>{i18nManager.Labels.view_all}</Btn>} />
        </div>
        <div className={styles["slider"]}>
            <div ref={trackRef} className={styles["track"]}>
                {tournaments.map((t, i) => (<TournamentCard key={t.external_id} index={i} tournament={t} onSelect={onSelect} />))}
            </div>
            {tournaments.length > 2 && (<div className={styles["container"]}>
                <div className={styles["arrows"]}>
                    <button className={styles["arrow"]} onClick={() => scroll(-1)} aria-label="Previous"><i className="fa fa-arrow-left" /></button>
                    <button className={styles["arrow"]} onClick={() => scroll(1)} aria-label="Next"><i className="fa fa-arrow-right" /></button>
                </div>
            </div>)}
        </div>
    </section>);
}

export default FeaturedTournaments;
